import ReactNativeTurnstile, { resetTurnstile } from './ReactNativeTurnstile';

export default ReactNativeTurnstile;
export { resetTurnstile };
